// extracted by mini-css-extract-plugin
module.exports = {"parkList":"ParkList_parkList__dYH21","region":"ParkList_region__z0FAj","regionTitle":"ParkList_regionTitle__FkVBz","link":"ParkList_link__zEQ_Z"};